import React from 'react'
import styles from './Details.scss'
import {browserHistory} from 'react-router'
import {SectionBox} from 'common/styleguide/SectionBox'
import {CTA} from 'common/styleguide/CTA'
import {Icon} from 'common/Icon'
import {formatText} from 'lib/textUtils'
import {Experience} from 'data/records'

export class Details extends React.PureComponent {
  render () {
    const {experience} = this.props

    return (
      <div>
        <SectionBox title='Details' noPadding>
          <div className={styles.cover} style={{backgroundImage: `url(${experience.cover})`}}>
            <div className={styles.headerGradient} />
            <div className={styles.header}>
              <div className={styles.logo} style={{backgroundImage: `url(${experience.logo})`}} />
              <div className={styles.nameContainer}>
                <div className={styles.name}>
                  <h2>{experience.name}</h2>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.content}>
            {(experience.startsOn || experience.location) && <div className={styles.dateLocation}>
              {experience.startsOn &&
                <h4>
                  <Icon i='md-calendar' size={25} className={styles.descIcon} />{Experience.formatDate(experience)}
                </h4>}
              {experience.location &&
                <h4>
                  <Icon i='md-pin' size={25} className={styles.descIcon} />{experience.location}
                </h4>}
              <hr className={styles.hr} />
            </div>}
            <div className={styles.description}>{formatText(experience.description, {autolink: true})}</div>
            <CTA margins={false} inline secondary className={styles.editButton} onClick={() => browserHistory.push(`/experiences/${experience.id}/details`)}>Edit Details</CTA>
          </div>
        </SectionBox>
      </div>
    )
  }
}
